export enum EServicePriceType {
  DYNAMIC = 'DYNAMIC',
  FIXED = 'FIXED',
  FREE = 'FREE',
}
